<template>
  <div class="verify-window">
    <div class="verify-window__title">请完成安全验证</div>
    <VantField
      class="verify-window__input"
      placeholder="请输入下图中的验证码"
      v-model="verifyCode"
      ref="coderRef"
    ></VantField>
    <div class="verify-window__coder-box flex">
      <img
        :src="`data:image/png;base64,${coderData.image_base64}`"
        class="verify-window__coder"
        @click="handleRefreshCoder"
      />
      <div class="verify-window__refresh" @click="handleRefreshCoder">
        看不清，换一张
      </div>
    </div>
    <div
      class="main-btn"
      :class="!canSubmitCoder && 'main-btn--disabled'"
      @click="handleSubmitCoder"
      :style="{
        color: color,
        backgroundColor: backgroundColor,
      }"
    >
      确认提交
    </div>
  </div>
</template>
<script>
import { Field, Toast } from "vant";
import Util from "../util";

export default {
  props: {
    color: {
      type: String,
      default: "",
    },
    backgroundColor: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showPopup: true,
      coderData: "",
      verifyCode: "",
    };
  },
  created() {
    this.handleRefreshCoder();
  },
  methods: {
    handleClose() {
      this.showPopup = false;
      this.$emit("onclose");
    },
    handleSubmitCoder() {
      if (Util.isEmptyString(this.verifyCode)) {
        this.$refs.coderRef.focus();
        Toast("请输入验证码");
        return;
      }
      this.$emit("onconfirm", {
        captcha: this.verifyCode,
        session: this.coderData.session_key,
      });
    },
    async handleRefreshCoder() {
      const [err, res] = await window.httpWrap(window.vsApi.getCaptchaCode({}));
      if (!res || err || res.retcode !== 200) {
        Toast({
          message: err.msg || res.msg || "获取验证码失败，请重试",
          duration: 1500,
        });
        return;
      }
      this.coderData = res.data;
    },
  },
  computed: {
    canSubmitCoder() {
      return !Util.isEmptyString(this.verifyCode);
    },
  },
  components: {
    VantField: Field,
  },
};
</script>
<style lang="scss" >
  .verify-window {
    width: 580px;
    height: 580px;
    background-color: #ffffff;
    border-radius: 24px;
    padding: 70px 58px;
    &__title {
      font-size: 36px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 40px;
    }
    &__input {
      width: 100%;
      height: 84px;
      display: flex;
      align-items: center;
      background-color: #ffffff;
      border-radius: 12px;
      border: 2px solid #e2e2e2;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 36px;
      margin: 50px auto 24px;
    }
    &__coder-box {
      width: 100%;
      height: 96px;
      justify-content: flex-start;
      margin-bottom: 50px;
    }

    &__coder {
      width: 228px;
      height: 96px;
      margin-right: 30px;
      background-color: #f5f5f5;
    }

    &__refresh {
      height: 36px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 36px;
    }

    .main-btn {
      width: 466px;
      height: 96px;
    }
  }
</style>
